import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

import { computeServiceChoiceOptions } from '../utils/compute-service-choice-options';

export const computeAnalyzeArticleContext = ({
  article,
  view,
  requestView,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelations;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  view.defects.canAddRemoveDefect = true;
  view.defects.fields.description.editable = true;
  view.defects.fields.photo.editable = true;
  view.defects.fields.context.editable = true;
  view.defects.fields.toBeRepaired.editable = true;
  view.defects.fields.brandResponsibility.toggle.editable = true;

  view.services.choice.shown = true;
  view.services.choice.editable = true;
  view.services.choice.serviceOptions = computeServiceChoiceOptions(article, view, 'analysis');

  view.services.actions.canAddAction = true;
  view.services.actions.canRemoveAction = true;
  view.services.actions.fields.description.editable = true;
  view.services.actions.fields.context.editable = true;
  view.services.actions.fields.photo.editable = true;
  view.services.actions.fields.associatedDefects.editable = true;
  view.services.actions.fields.additionalInfo.editable = true;
  view.services.actions.fields.brandResponsibility.editable = true;
  view.services.actions.fields.spareParts.canAddRemoveSparePart = true;
  view.services.actions.fields.spareParts.referenceNumber.editable = true;
  view.services.actions.fields.spareParts.quantity.editable = true;

  view.services.actions.fields.workshopPrice.editable = true;
  view.services.actions.fields.workshopPrice.required = true;
  view.services.actions.fields.spareParts.workshopPrice.editable = true;
  view.services.actions.fields.spareParts.workshopPrice.required = true;

  view.services.exchange.workshopPrice.editable = true;
  view.services.exchange.workshopPrice.required = true;

  view.services.actions.fields.organizationPrice.editable =
    requestView.organizationPrice.editable &&
    !!article.workshopOrganization?.workshopConfig?.organizationPrice?.editable;
  view.services.actions.fields.spareParts.organizationPrice.editable =
    requestView.organizationPrice.editable &&
    !!article.workshopOrganization?.workshopConfig?.organizationPrice?.editable;
  view.services.exchange.organizationPrice.editable =
    requestView.organizationPrice.editable &&
    !!article.workshopOrganization?.workshopConfig?.organizationPrice?.editable;

  view.services.exchange.exchangeType.editable = true;
  view.services.exchange.replacementProduct.editable = true;
};
